import { CardHeader, NuvoCard } from '@nuvolo/nuux-core/components/NuvoCard';
import { NuvoGrid } from '@nuvolo/nuux-core/components/NuvoGrid';
import type { PropsWithChildren } from 'react';
import React from 'react';
import { color } from '@nuvolo/nuux-theme/utils';
import { NuvoBox } from '@nuvolo/nuux-core/components/NuvoBox';
import { useSwitch } from '@nuvolo/nuux-core/hooks/useSwitch';
import { DataGrid } from 'devextreme-react';
import { DashboardStatsPoint } from '#/graphql/types';
import If from '#/common/components/If';
import styled from 'styled-components';
import StandardThrobber from '#/app/components/Throbbers/StandardThrobber';

const TmmCard = styled(NuvoGrid)`
  > div {
    position: relative;
    background: ${color('custom', 'cardBackground', 0.2)} !important;
    backdrop-filter: blur(20px);
    border: 1px solid ${color('secondary', 'light2')} !important;
    overflow: hidden;
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: ${color('contrast', 'light', 0.05)};
      pointer-events: none;
    }
    border-radius: 48px !important;
    padding: 12px !important;
    height: 100%;
    > div {
      border: none !important;
      height: 100%;
    }
    svg {
      width: 100% !important;
      height: 100% !important;
    }
    h2 {
      font-size: 16px !important;
      font-weight: 600 !important;
    }
    h4 {
      font-weight: 400 !important;
      font-size: 14px !important;
      color: ${color('custom', 'contrastText')} !important;
    }
  }

  .header-container > div > div > div > div > div,
  .header-container > div > div > div > div > div > div > h1 {
    width: 100%;
  }
`;

export interface DashboardItemProps extends PropsWithChildren {
  title?: string;
  subtitle?: string;
  showTitle?: boolean;
  data?: DashboardStatsPoint[];
  customButtons?: React.ReactElement;
  loading?: boolean;
}

const DashboardItem: React.FC<DashboardItemProps> = ({
  title,
  subtitle,
  showTitle = true,
  children,
  data,
  customButtons,
  loading,
  ...props
}) => {
  const { value: chartVisible, toggle: toggleChart } = useSwitch(true);

  return (
    <TmmCard item xs={12} md={6} xl={6} {...props}>
      <NuvoCard>
        <If condition={showTitle && !!title}>
          <div className="header-container">
            <CardHeader
              title={
                (
                  <NuvoBox display="flex" width="100%" justifyContent="space-between">
                    <NuvoBox flex="1" width="100%">
                      <h2>{title}</h2>
                      {subtitle && <h4>{subtitle}</h4>}
                    </NuvoBox>
                    {customButtons}
                    {/* {!!data && (
                    <ToggleIcon>
                      <NuvoIconButton
                        source="material-symbols"
                        icon={chartVisible ? 'table' : 'area_chart'}
                        onClick={toggleChart}
                      />
                    </ToggleIcon>
                  )} */}
                  </NuvoBox>
                ) as unknown as string
              }
            />
          </div>
        </If>
        <If condition={loading}>
          <NuvoBox style={{ alignContent: 'center' }} height={400}>
            <StandardThrobber />
          </NuvoBox>
        </If>
        <If condition={!loading}>
          <If condition={chartVisible}>{children}</If>
          <If condition={!chartVisible}>
            <DataGrid dataSource={data} height={400} />
          </If>
        </If>
      </NuvoCard>
    </TmmCard>
  );
};

export default React.memo(DashboardItem);
